import { SITE_URL } from './site';

export const DEFAULT_DESCRIPTION =
  'Shop groceries online from local supermarkets in Jamaica. Compare prices, order for pickup or delivery, and pay securely with Pack My Cart.';

export const DEFAULT_OG_IMAGE = '/pmcBigLogo.png';

export const DEFAULT_KEYWORDS =
  'groceries, online shopping, supermarket, Jamaica, delivery, pickup, WiPay, Pack My Cart';

/** Static routes included in sitemap.xml (generated at build time). */
export const INDEXABLE_ROUTES = [
  { path: '/', changefreq: 'daily', priority: '1.0' },
  { path: '/products', changefreq: 'daily', priority: '0.9' },
  { path: '/supermarkets', changefreq: 'daily', priority: '0.9' },
  { path: '/how-it-works', changefreq: 'monthly', priority: '0.8' },
  { path: '/faq', changefreq: 'monthly', priority: '0.8' },
  { path: '/privacy-policy', changefreq: 'yearly', priority: '0.3' },
  { path: '/terms-of-service', changefreq: 'yearly', priority: '0.3' },
  { path: '/refund-policy', changefreq: 'yearly', priority: '0.3' },
] as const;

export function buildCanonicalUrl(path = '/'): string {
  const base = SITE_URL.replace(/\/$/, '');
  if (!path || path === '/') return base;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
}

export function buildOgImageUrl(imagePath?: string | null): string {
  const path = imagePath || DEFAULT_OG_IMAGE;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${SITE_URL.replace(/\/$/, '')}${path.startsWith('/') ? path : `/${path}`}`;
}
